module.exports = __webpack_public_path__ + "static/media/goldenprize-mackerel-natural.43f42d02.png";